import Nav from "./Sections-Home/nav";

export default function Doc() {

    return (
        <Nav />
    );
}